import { shipmentIsBooked } from "utils";

export function getDefaultFilter(shipment: CondensedShipment): QuoteFilterType {
  if (!shipment?.info) {
    return "ALL";
  }

  if (shipment.info.type === "QUOTES_ONLY") {
    return "ALL";
  }

  if (shipmentIsBooked(shipment)) {
    return "ACCEPTED";
  }

  if (
    shipment.shipment_status === "EXPIRED" ||
    shipment.shipment_status === "CANCELLED"
  ) {
    return "ALL";
  }
  return "ACTIVE";
}
